import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js/pure"

import { BankAccountDetails } from "./components/BankAccountDetails"
import { SepaAdvisor } from "./components/SepaAdvisor"
import { Pearl, PearlProvider } from "@oysterhr/pearl"
import ConnectPaymentMethodLayout from "../../../layouts/ConnectPaymentMethodLayout"

const SepaFlowPage = () => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow")
  const stripePromise = useMemo(() => loadStripe(window.gon.stripeOysterHrLtdPublishableKey), [])

  return (
    <PearlProvider>
      <ConnectPaymentMethodLayout title={t("title")}>
        <div className="text-left" style={{ width: 600 }}>
          <Elements stripe={stripePromise}>
            <div
              className="relative rounded-lg border-2 border-gray-200 bg-white p-2 text-left md:p-8"
              style={{ width: 600 }}
            >
              <BankAccountDetails />
            </div>
          </Elements>
        </div>

        <div className="text-left">
          <Pearl name="sepa-bank-details">
            <Pearl.SideBox>
              <SepaAdvisor />
            </Pearl.SideBox>
          </Pearl>
        </div>
      </ConnectPaymentMethodLayout>
    </PearlProvider>
  )
}

export default SepaFlowPage
